import "./checkanimation.css";
import "./erroranimation.css";

// Variante de CheckAnimation para pagos fallidos: mismo círculo animado, en rojo y con una cruz
const ErrorAnimation = () => {

  return (
    <>
      <div className="contenedor-check contenedor-check--error">
        <svg viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="45" />
          <path className="crossmark" d="M 34 34 L 66 66" />
          <path className="crossmark crossmark-2" d="M 66 34 L 34 66" />
        </svg>
      </div>
    </>
  )
}

export default ErrorAnimation;
